<template>
  <div class="betConfirmationModal">
    <div class="header">
      <p class="title">{{ $t('cancelBetButton') }}</p>
      <img class="close" src="/img/icons/bone_close.svg" alt="close" @click="emit('get-out')" />
    </div>
    <div class="body">
      <p class="text">
        {{ $t('flipCoinCancelBetText') }}
      </p>
      <div class="cancelBetWrapper">
        <button class="btn-outline" @click="emit('get-out')">
          {{ $t('flipCoinCancelBetDiscard') }}
        </button>
        <TavernFlipCoinBigButton
          class="getOutBtn"
          :label="$t('flipCoinCancelBetConfirm')"
          @click="$emit('cancel-bet')"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['get-out', 'cancel-bet']);
</script>

<style lang="scss" scoped>
.betConfirmationModal {
  width: 461px;
  height: auto;
  padding-bottom: 20px;

  border-radius: 12px;
  background: linear-gradient(to bottom, #4e3127, #000000);
  margin: 0 auto;
  padding-top: 7px;
  margin-top: 7%;
  z-index: 9999;
  position: absolute;
  left: 25%;
  border: 1px solid #483b20;

  @media screen and (max-width: 479px) {
    width: 99vw;
    margin-top: 0;
    left: 0;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: -5px 20px;

  .title {
    font-size: 32px;
    font-weight: 700;
    color: #fff;
    max-width: 80%;
    margin: 0 auto;
    font-family: Grenze, sans-serif;
    text-align: center;
  }

  .close {
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.body {
  text-align: center;
  margin-top: 20px;

  button {
    height: 54px;
  }

  .text {
    color: #fff;
    font-size: 20px;
    font-weight: 500;
  }

  .cancelBetWrapper {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0 20px;
  }

  .btn-outline {
    font-size: 18px;
    width: 100%;
    padding: 0 20px;
  }

  .getOutBtn {
    margin: 0px;
    line-height: 24px;
    padding: 0 24px;
    margin-left: 15px;
    font-size: 18px;
    width: 100%;
    max-width: 100%;
  }
}
</style>
